import { Button } from 'components/UI';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from "@fortawesome/pro-solid-svg-icons/faLock";
import { pleaseLoginCss } from 'css/myalbums';

export default function PleaseLogin(props) {
  return (
    <div className="please-login">
      <div className="security">
        <FontAwesomeIcon icon={faLock} />
      </div>

      <Button
        onClick={props.onClick}
        className="filled"
      >{props.buttonLabel}</Button>

      <style jsx>{pleaseLoginCss}</style>
    </div>
  );
}